// extracted by mini-css-extract-plugin
module.exports = {"policy":"PrivacyPolicy_policy__3c82F","verticalLine":"PrivacyPolicy_verticalLine__2kqfH","privacy":"PrivacyPolicy_privacy__3A2PL"};